export default [
  {
    description: 'GED Estudante',
    path: '/ged/gedestudante',
    name: 'ged-estudante',
    component: () => import('@/views/ged/gedestudante/Index.vue'),
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Documento do Estudante',
    parent: 'ged-estudante',
    path: '/ged/gedestudante/cadastro/:id?',
    name: 'ged-estudante-create',
    component: () => import('@/views/ged/gedestudante/InclusaoEdicao.vue'),
    goesToMenu: false,
  },
];
